// extracted by css-extract-rspack-plugin
export default {"root":"EGrTXJNu0Q8KmTUM","content":"dFQ9tAYKyvsbbaXG","collapsed":"UAnM6EpVy9cePkFQ","expanded":"DhFUKyCBRFgNhyr_","fade":"becU3St1hoYJrIjl"};